import i18next from "i18next";

export const formatNumber = (num: number) => {
  const lang = i18next.language;
  const locale = lang.startsWith("ar") ? "ar-EG" : "en-US";

  return new Intl.NumberFormat(locale, {
    useGrouping: true,
  }).format(num);
};

const WESTERN_DIGITS = "0123456789";
const ARABIC_INDIC_DIGITS = "٠١٢٣٤٥٦٧٨٩";
const EXTENDED_ARABIC_INDIC_DIGITS = "۰۱۲۳۴۵۶۷۸۹";

const normalizeDigits = (value: string) => {
  return value.replace(/[٠-٩۰-۹]/g, (digit) => {
    const arabicIndex = ARABIC_INDIC_DIGITS.indexOf(digit);
    if (arabicIndex !== -1) {
      return WESTERN_DIGITS[arabicIndex];
    }

    const extendedIndex = EXTENDED_ARABIC_INDIC_DIGITS.indexOf(digit);
    if (extendedIndex !== -1) {
      return WESTERN_DIGITS[extendedIndex];
    }

    return digit;
  });
};

export const formatPhoneNumber = (phone: string | number) => {
    if (!phone) return "-------";
    const normalizedPhone = normalizeDigits(phone.toString());
    if (normalizedPhone.startsWith("9665")) {
        return `05${normalizedPhone.slice(4)}`;
    }
    return normalizedPhone;
};

export function formatTime(rawTime: string) {
  if (!rawTime) return "-------";

  const [hours, minutes] = rawTime.split(":").map(Number);
  const date = new Date();
  date.setHours(hours, minutes, 0);

  const locale = i18next.language.startsWith("ar") ? "ar-EG" : "en-GB";

  return date.toLocaleTimeString(locale, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
}
